

































































import { Vue, Component, Prop } from "vue-property-decorator";

import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { AD_FORMAT_MAP, INVENTORY_TYPE_MAP,  } from '@/const/options/index';
import { FormType } from "@/pages/campaign/adset/ad/editingTypes";
import { LoadedCreative, OriginCreative, IInventoryAsTableRow } from "@/pages/campaign/adset/ad/editingTypes";

@Component<AdForm>({
    name: 'AdForm'
})
export default class AdForm extends Vue {
    @Prop({type: Object, required: true}) private value!: FormType;
    @Prop({type: Array, required: true}) private inventoryData!: IInventoryAsTableRow[];
    @Prop({type: Boolean, required: true}) private loading!: boolean;
    @Prop({type: Boolean, required: true}) private zoomImgDialogVisible!: boolean;
    @Prop({
        validator: (val: OriginCreative | LoadedCreative | null) => (val === null || typeof val === 'object'),
        required: true
    }) private zoomImg!: OriginCreative | LoadedCreative | null;
    
    get form() { return this.value }
    set form(v: FormType) { this.$emit('input', v) }


    get loadingSync() { return this.loading }
    set loadingSync(v: boolean) { this.$emit('update:loading', v) }

    get zoomImgDialogVisibleSync() { return this.zoomImgDialogVisible }
    set zoomImgDialogVisibleSync(v: boolean) { this.$emit('update:zoomImgDialogVisible', v) }
    
    get zoomImgSync() { return this.zoomImg }
    set zoomImgSync(v: OriginCreative | LoadedCreative | null) { this.$emit('update:zoomImg', v) }

    private compTerms = compTerms;

    private AD_FORMAT_MAP = AD_FORMAT_MAP;
    private INVENTORY_TYPE_MAP = INVENTORY_TYPE_MAP;

    
    private showImg(img: OriginCreative | LoadedCreative | null) {
        this.zoomImgDialogVisibleSync = true;
        this.zoomImgSync = img;
    }
    private removeImg(e: any, row: IInventoryAsTableRow, img: OriginCreative) {
        if (img.origin) {
            row.creative.filter((v: OriginCreative) => {
                return v.id === img.id && v.url === img.url
            })
                .forEach((v: OriginCreative) => {
                    row.creative.splice(row.creative.indexOf(v), 1);
                });
            row.usable.push({
                selected: false,
                format:         img.format,
                origin:         img.origin,
                folder_id:      img.folder_id,
                id:             img.id,
                name:           img.name,
                type:           img.type,
                url:            img.url,
                sspFormat:      img.sspFormat,
                bg_color:       img.bg_color,
            });
            row.usable = [
                ...row.usable.sort((a: LoadedCreative, b: LoadedCreative) => {
                    if (a.origin && b.origin || (!a.origin && !b.origin)) {
                        return a.id < b.id ? -1 : 1;
                    }
                    return a.origin ? -1 : 1
                })
            ];
        } else {
            row.creative.filter((v: OriginCreative) => {
                return v.id === img.id && v.url === img.url
            })
                .forEach((v: OriginCreative) => {
                    row.creative.splice(row.creative.indexOf(v), 1);
                });
            row.usable.filter((creative: LoadedCreative) => creative.id === img.id)
                .forEach((creative: LoadedCreative) => {
                    creative.selected = false;
                })
        }
    }
    private appendImg(e: any, row: IInventoryAsTableRow, img: LoadedCreative) {
        if (img.origin) {
            row.usable.filter((v: LoadedCreative) => v.id === img.id && v.url === img.url)
                .forEach((v: LoadedCreative) => {
                    row.usable.splice(row.usable.indexOf(v), 1);
                })
        } else {
            img.selected = true;
        }
        row.creative.push({
            format:         img.format,
            origin:         img.origin,
            folder_id:      img.folder_id,
            id:             img.id,
            name:           img.name,
            type:           img.type,
            url:            img.url,
            sspFormat:      img.sspFormat,
            bg_color:       img.bg_color,
        });
        row.creative = [
            ...row.creative.sort((a: OriginCreative, b: OriginCreative) => {
                if (a.origin && b.origin || (!a.origin && !b.origin)) {
                    return a.id < b.id ? -1 : 1;
                }
                return a.origin ? -1 : 1
            }),
        ] as OriginCreative[];
    }
}
